<template>
    <app-modal-view @close="discardUnsavedChanges">
        <template v-slot:header>
            <div class>
                <p v-t="'project.settings.project_settings'" class="is-size-5 has-text-centered" />
            </div>
        </template>

        <template v-slot:body>
            <div class="lb-project-modal-content">
                <project-configuration-mailing-options @update="updateConf" />
            </div>
        </template>

        <template v-slot:footer>
            <div class="field is-grouped lb-project-modal-footer pb-4">
                <p class="control">
                    <button
                        v-t="'close'"
                        class="button is-black is-uppercase has-text-weight-bold"
                        @click="discardUnsavedChanges"
                    />
                </p>
                <p class="control">
                    <button
                        v-t="'Buttons.save_and_close'"
                        :class="{ 'is-loading': saving }"
                        :disabled="!hasChanges"
                        class="button is-primary is-uppercase has-text-weight-bold"
                        @click="saveChanges"
                    />
                </p>
            </div>
        </template>
    </app-modal-view>
</template>

<script>
import AppModalView from '@/components/AppModalView';
import ProjectConfigurationMailingOptions from '@/components/ProjectConfigurationMailingOptions';
import _ from 'underscore';
export default {
    components: {
        AppModalView,
        ProjectConfigurationMailingOptions,
    },
    props: {},
    data() {
        return {
            project: this.projectSource,
            saving: false,
            pendingChanges: false,
        };
    },
    computed: {
        hasAdminPermission() {
            return this.$store.getters.project.accessLevel == 'administrator';
        },
        hasEditPermission() {
            return this.$store.getters.project.accessLevel == 'edit';
        },
        canEdit() {
            return this.hasAdminPermission || this.hasEditPermission;
        },
        hasChanges() {
            return !_.isEqual(
                this.project.userConfiguration.mailing,
                this.$store.state.project.userConfiguration.mailing
            ) || !_.isEqual(
                this.project.watching,
                this.$store.state.project.watching
            );
        },
        projectSource() {
            if (
                this.hasAdminPermission &&
                !this.$store.getters.project.folder
            ) {
                const proj = this.$store.getters.project;
                proj.folder = {};
                return proj;
            }
            return this.$store.getters.project;
        },
    },
    watch: {
        projectSource: {
            handler: function () {
                this.project = JSON.parse(JSON.stringify(this.projectSource));
            },
            immediate: true,
        },
    },
    methods: {
        updateConf(conf) {
            console.log("in updateConf")
            this.project.userConfiguration.mailing = conf;
        },
        saveChanges() {
            console.log(this.project._id);
            console.log(this.project.userConfiguration);
            this.saving = true;
            this.$store
                .dispatch('updateUserProjectConfiguration', {
                    projectId: this.project._id,
                    userConfigurationData: this.project.userConfiguration,
                })
                .then(() => {
                    this.$emit('close');
                })
                .finally(() => {
                    this.saving = false;
                })
                .catch((e) => {
                    //show error
                    console.error(e);
                });
        },
        discardUnsavedChanges() {
            if (this.hasChanges) {
                console.log('discarding changes');
            }
            this.$emit('close');
        },
    },
};
</script>

<style scoped>
.lb-project-modal-footer {
    margin: 0 auto;
}
.lb-project-modal-content {
    height: calc(100vh - 60vh);
}
</style>
